"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : CONTENT TYPE --------------- ++++++++++ */


var _default = {
  contenttype: {
    display: 'inline-flex',
    marginRight: (0, _index.pxToEm)(2),
    position: 'relative',
    verticalAlign: 'middle',
    width: 'fit-content',
    '&:last-child': {
      marginRight: '0'
    },
    '& .contenttypeinner': {
      borderRadius: (0, _index.pxToEm)(12),
      display: 'block',
      width: (0, _index.pxToEm)(60),
      // was 65 (needed to reduce because we added stories)
      height: (0, _index.pxToEm)(24),
      '&.withcount-true': {
        width: 'auto',
        minWidth: (0, _index.pxToEm)(60),
        '& .icon': {
          padding: "0 ".concat((0, _index.pxToEm)(8)),
          '& .count': {
            marginLeft: (0, _index.pxToEm)(5)
          }
        }
      }
    },
    '& .icon': {
      background: _index.theme.color.neutral.medium.swatch,
      borderRadius: 'inherit',
      userSelect: 'none',
      color: _index.theme.color.light.light.swatch,
      extend: _index.theme.typography.size.xsmall,
      lineHeight: '1.7',
      textTransform: 'capitalize',
      textAlign: 'center',
      display: 'block',
      width: '100%',
      height: '100%',
      transition: 'filter .2s linear 0s'
    },
    '&:hover': {
      '& .icon': {
        filter: 'brightness(85%)'
      },
      // content types
      '&.quiz': {
        '&.live-true, &.selected-true': {
          '& .icon': {
            filter: 'brightness(100%)'
          }
        }
      },
      '&.poll': {
        '&.live-true, &.selected-true': {
          '& .icon': {
            filter: 'brightness(100%)'
          }
        }
      },
      '&.story': {
        '&.live-true, &.selected-true': {
          '& .icon': {
            filter: 'brightness(100%)'
          }
        }
      },
      '&.profile': {
        '&.live-true, &.selected-true': {
          '& .icon': {
            filter: 'brightness(100%)'
          }
        }
      }
    },
    // content types
    '&.quiz': {
      '&.live-true, &.selected-true': {
        '& .icon': {
          background: _index.theme.color.quiz.medium.swatch,
          cursor: 'default',
          pointerEvents: 'none'
        }
      }
    },
    '&.poll': {
      '&.live-true, &.selected-true': {
        '& .icon': {
          background: _index.theme.color.poll.medium.swatch,
          cursor: 'default',
          pointerEvents: 'none'
        }
      }
    },
    '&.story': {
      '&.live-true, &.selected-true': {
        '& .icon': {
          background: _index.theme.color.story.medium.swatch,
          cursor: 'default',
          pointerEvents: 'none'
        }
      }
    },
    '&.profile': {
      '&.live-true, &.selected-true': {
        '& .icon': {
          background: _index.theme.color.profile.medium.swatch,
          cursor: 'default',
          pointerEvents: 'none'
        }
      }
    },
    // indicator types
    '&.sort': {
      '& .icon': {
        cursor: 'pointer'
      }
    },
    '&.select': {
      '& .icon': {
        cursor: 'pointer'
      }
    },
    '&.key': {
      '& .icon': {
        cursor: 'default'
      }
    }
  }
};
exports.default = _default;